export const MANUAL_COPY = {
  moduleName: 'Manual de operaciones',
  noticeBadge: 'Manual actualizado',
  noticeTitle: 'Hay una nueva versión del manual',
  noticeLead: 'Antes de seguir, revisa qué cambió. Esta ventana aparecerá cada vez que entres hasta que confirmes.',
  whatChanged: 'Qué cambió',
  viewChanges: 'Ver los cambios',
  acknowledge: 'Leí y entendí',
  acknowledging: 'Guardando…',
  acknowledged: 'Confirmaste esta versión',
  pendingBar: 'Todavía no confirmas que leíste esta versión.',
  pendingShort: 'Falta confirmar',
  currentVersion: 'Versión vigente',
  publishedOn: 'Publicada el',
  newsTitle: 'Novedades de esta versión',
  downloadPdf: 'Descargar PDF',
  preparingPdf: 'Preparando…',
  pdfError: 'No se pudo descargar el PDF. Intenta de nuevo.',
  chaptersTitle: 'Capítulos',
  changedCount: 'capítulos cambiaron en esta versión',
  searchLabel: 'Buscar en el manual',
  searchPlaceholder: 'Ej.: alérgenos, limpieza, caja',
  searchHint: 'Escribe al menos 3 letras.',
  searchEmpty: 'No encontramos nada con esa palabra.',
  searching: 'Buscando…',
  history: 'Historial de versiones',
  historyLead: 'Todas las versiones publicadas, de la más nueva a la más antigua.',
  historyCurrent: 'Vigente',
  backToManual: 'Volver al manual',
  index: 'Índice',
  previous: 'Anterior',
  next: 'Siguiente',
  changedChapterNotice: 'Este capítulo cambió en esta versión.',
  newChapterNotice: 'Este capítulo es nuevo en esta versión.',
  loading: 'Cargando…',
  notAvailable: 'El manual todavía no está disponible para tu cocina.',
  loadError: 'No pudimos cargar el manual. Revisa tu conexión e intenta de nuevo.',
  retry: 'Reintentar',
};

export const CHANGE_STATUS = {
  new: 'new',
  updated: 'updated',
  unchanged: 'unchanged',
};

export const CHANGE_BADGES = {
  [CHANGE_STATUS.new]: 'Nuevo',
  [CHANGE_STATUS.updated]: 'Actualizado',
};

export const MANUAL_ROUTES = {
  home: 'operations-manual',
  chapter: 'operations-manual-chapter',
  history: 'operations-manual-history',
};

export const MANUAL_BASE_PATH = '/manual-operaciones';

const DATE_LOCALE = 'es-PE';
const DATE_FORMAT = { day: 'numeric', month: 'long', year: 'numeric' };

export function formatManualDate(isoDate) {
  return isoDate ? new Intl.DateTimeFormat(DATE_LOCALE, DATE_FORMAT).format(new Date(isoDate)) : '';
}

export function changeNoteLines(changeNotes) {
  return (changeNotes || '').split('\n').map((line) => line.trim()).filter(Boolean);
}
